var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-input-group",
    { attrs: { size: _vm.size } },
    [
      _vm.$slots.prepend
        ? _c("b-input-group-prepend", [_vm._t("prepend")], 2)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-input",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: _vm.mask,
                  expression: "mask"
                }
              ],
              ref: "input",
              attrs: {
                required: _vm.required,
                placeholder: _vm.placeholder,
                disabled: _vm.disabled,
                type: _vm.type,
                readonly: _vm.readonly,
                name: _vm.name ? _vm.name : _vm.randomAttributeValueString(),
                autofocus: _vm.autofocus,
                autocomplete:
                  _vm.autocomplete !== "off"
                    ? _vm.autocomplete
                    : _vm.randomAttributeValueString(),
                value: _vm.value,
                state: _vm.state,
                min: _vm.min,
                max: _vm.max,
                formatter: _vm.formatter,
                size: _vm.size
              },
              nativeOn: {
                focus: function($event) {
                  return _vm.onFocus($event)
                },
                blur: function($event) {
                  return _vm.onBlur($event)
                }
              }
            },
            "b-form-input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      !_vm.noControls
        ? _c(
            "b-input-group-append",
            [
              _vm.isValid && _vm.loading !== true
                ? _c("div", { staticClass: "valid-indicator" }, [
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass: "fas fa-check-circle",
                      attrs: { title: "Заполнено верно" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading === true,
                        expression: "loading === true"
                      }
                    ],
                    staticClass: "loading-indicator"
                  },
                  [
                    _c("b-spinner", {
                      attrs: {
                        small: "",
                        variant: "primary",
                        label: "Spinning"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.noBackspace
                ? _c(
                    "b-btn",
                    {
                      ref: "clearButton",
                      staticClass: "outline-input-special",
                      class: _vm.buttonClasses,
                      attrs: {
                        size: _vm.size,
                        disabled: !_vm.value || _vm.disabled || _vm.readonly
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changed("")
                        }
                      }
                    },
                    [_c("i", { staticClass: "far fa-backspace" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("append")
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }